/// <amd-module name="Artifacts/Cargo/commands/GetLink" />
import { getLinkCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createGetLinkCommand = getLinkCommandCreator();
